<template>
  <div class="cargoInquiry" v-if="wayBillData">
    <div class="detail">
      <div class="detail-title">
        <van-image width="20" height="20" :src="truckIcon"></van-image>
        <span class="detail-title-label">{{ $t.cargoInquiry.title1 }}</span>
      </div>
      <div class="detail-item" style="width: 100%">
        <van-image width="15" height="15" :src="wbNumberIcon"></van-image>
        <span class="detail-item-label">{{ $t.cargoInquiry.wbNumber }}</span>
        <span class="detail-item-value">{{ wbNumber }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="planeIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.wbTypeStr }}
        </span>
        <span class="detail-item-value">{{ wBTypeStr }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="clockIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.logisticsStatus }}
        </span>
        <span class="detail-item-value">{{ logisticsStateStr }}</span>
      </div>
    </div>

    <div
      class="detail"
      v-if="wayBillData.TakeDeliveryType && wayBillData.TakeDeliveryType == 2"
    >
      <div class="detail-title">
        <van-image width="20" height="20" :src="addressIcon"></van-image>
        <span class="detail-title-label">{{ $t.cargoInquiry.title2 }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="userIcon"></van-image>
        <span class="detail-item-label">{{ $t.cargoInquiry.receivingName }}</span>
        <span class="detail-item-value">{{
          wayBillData.CustomerReceiving.ReceivingName
        }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="phoneIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.phoneNumber }}
        </span>
        <span class="detail-item-value">{{
          wayBillData.CustomerReceiving.PhoneNumber
        }}</span>
      </div>
      <div class="detail-item" style="width: 100%">
        <van-image width="15" height="15" :src="navigationIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.receivingAddress }}
        </span>
        <span class="detail-item-value">{{
          wayBillData.CustomerReceiving.ReceivingAddress
        }}</span>
      </div>
    </div>

    <div class="detail">
      <div class="detail-title">
        <van-image width="20" height="20" :src="postIcon"></van-image>
        <span class="detail-title-label">{{ $t.cargoInquiry.title3 }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="boxNumberIcon"></van-image>
        <span class="detail-item-label">{{ $t.cargoInquiry.boxNumber }}</span>
        <span class="detail-item-value">{{ wayBillData.AllBoxNumber }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="volumeIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.volume }}
        </span>
        <span class="detail-item-value">{{ wayBillData.AllVolume }} cbm</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="weightIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.weight }}
        </span>
        <span class="detail-item-value">{{ wayBillData.AllWeight }} KG</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="shipIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.pol }}
        </span>
        <span class="detail-item-value">{{ wayBillData.DeliveryCountryCity }}</span>
      </div>
      <div class="detail-item">
        <van-image width="15" height="15" :src="locationIcon"></van-image>
        <span class="detail-item-label">
          {{ $t.cargoInquiry.pod }}
        </span>
        <span class="detail-item-value">{{ wayBillData.DestinationCountryCity }}</span>
      </div>
    </div>

    <div class="detail" v-if="wayBillData.CargoList && wayBillData.CargoList.length > 0">
      <div class="detail-title">
        <van-image width="20" height="20" :src="expressIcon"></van-image>
        <span class="detail-title-label">{{ $t.cargoInquiry.title4 }}</span>
      </div>
      <div
        class="detail-items"
        v-for="(item, index) in wayBillData.CargoList"
        :key="index"
      >
        <div class="detail-item">
          <span class="detail-item-label">{{ $t.cargoInquiry.cargoName }}</span>
          <span class="detail-item-value">{{ item.CargoName }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-label">
            {{ $t.cargoInquiry.cargoQuantity }}
          </span>
          <span class="detail-item-value">{{ item.CargoQuantity }} {{ item.QuantityUnit }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-label">
            {{ $t.cargoInquiry.numberPackages }}
          </span>
          <span class="detail-item-value">{{ item.NumberPackages }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-label">
            {{ $t.cargoInquiry.volume }}
          </span>
          <span class="detail-item-value">{{ item.Volume }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-label">
            {{ $t.cargoInquiry.weight }}
          </span>
          <span class="detail-item-value">{{ item.Weight }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-item-label">
            {{ $t.cargoInquiry.goodsValue }}
          </span>
          <span class="detail-item-value">{{ item.GoodsValue }} {{ item.Currency }}</span>
        </div>
        <div class="detail-items-image" v-if="item.PictureCover">
          <van-image
            width="50"
            height="50"
            fit="cover"
            :src="imgUrlFilter(item.PictureCover)"
            @click="imagePreview(imgUrlFilter(item.PictureCover))"
          ></van-image>
        </div>
      </div>
    </div>

    <div class="detail" v-if="wayBillData.CargoList && wayBillData.CargoList.length > 0">
      <div class="detail-title">
        <van-image width="20" height="20" :src="branchIcon"></van-image>
        <span class="detail-title-label">{{ $t.cargoInquiry.title5 }}</span>
      </div>
      <van-steps
        direction="vertical"
        :active="0"
        active-color="#000"
        :active-icon="circle1"
        :inactive-icon="circle2"
      >
        <van-step v-for="(item, index) in wayBillData.LogisticsList" :key="index">
          <div class="step-label">{{ item.LogisticsInfo }}</div>
          <div class="step-content">
            {{ item.LogisticsTime }}
          </div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Icon, Step, Steps, Image } from "vant";

Vue.use(Button).use(Icon).use(Step).use(Steps).use(Image);

export default {
  name: "cargoInquiry",
  data() {
    return {
      wbNumber: "",
      wBTypeStr: "",
      logisticsStateStr: "",
      wayBillData: null,
      //1
      truckIcon: require("@/assets/img/order/truck.png"),
      wbNumberIcon: require("@/assets/img/order/wbNumber.png"),
      planeIcon: require("@/assets/img/order/plane.png"),
      clockIcon: require("@/assets/img/order/clock.png"),
      //2
      addressIcon: require("@/assets/img/order/address.png"),
      userIcon: require("@/assets/img/order/user.png"),
      phoneIcon: require("@/assets/img/order/phone.png"),
      navigationIcon: require("@/assets/img/order/navigation.png"),
      //3
      postIcon: require("@/assets/img/order/post.png"),
      boxNumberIcon: require("@/assets/img/order/boxNumber.png"),
      volumeIcon: require("@/assets/img/order/volume.png"),
      weightIcon: require("@/assets/img/order/weight.png"),
      shipIcon: require("@/assets/img/order/ship.png"),
      locationIcon: require("@/assets/img/order/location.png"),
      //4
      expressIcon: require("@/assets/img/order/express.png"),
      //5
      branchIcon: require("@/assets/img/order/branch.png"),
      circle1: require("@/assets/img/order/circle1.png"),
      circle2: require("@/assets/img/order/circle2.png"),
    };
  },
  created() {
    const query = this.$route.query;
    if (query.wbNumber) {
      this.wbNumber = query.wbNumber;
      this.getWaybillDetail();
    }
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.cargoInquiry.copySuccess,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getWaybillDetail() {
      this.$commonMethod.showLoading();
      var param = { WB_Number: this.wbNumber };
      this.$api.inquiry
        .getCargoLogisticsInfo(param)
        .then((res) => {
          if (res.data) {
            this.wayBillData = res.data;
            if (this.wayBillData.WB_Type == 1) {
              this.wBTypeStr = this.$t.cargoInquiry.wbType1;
            }
            if (this.wayBillData.WB_Type == 2) {
              this.wBTypeStr = this.$t.cargoInquiry.wbType2;
            }
            if (this.wayBillData.WB_Type == 3) {
              this.wBTypeStr = this.$t.cargoInquiry.wbType3;
            }
            if (this.wayBillData.WB_Type == 4) {
              this.wBTypeStr = this.$t.cargoInquiry.wbType4;
            }
            if (this.wayBillData.WB_Type == 5) {
              this.wBTypeStr = this.$t.cargoInquiry.wbType5;
            }

            if (this.wayBillData.LogisticsState == 1) {
              this.logisticsStateStr = this.$t.cargoInquiry.logisticsState1;
            }
            if (this.wayBillData.LogisticsState == 2) {
              this.logisticsStateStr = this.$t.cargoInquiry.logisticsState2;
            }
            if (this.wayBillData.LogisticsState == 3) {
              this.logisticsStateStr = this.$t.cargoInquiry.logisticsState3;
            }
            if (this.wayBillData.LogisticsState == 4) {
              this.logisticsStateStr = this.$t.cargoInquiry.logisticsState4;
            }
            if (this.wayBillData.LogisticsState == 5) {
              this.logisticsStateStr = this.$t.cargoInquiry.logisticsState5;
            }
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargoInquiry {
  width: 100%;
  display: inline-block;
  .van-steps {
    background: transparent;
    padding: 0 0 15px 28px;
    .van-step {
      padding: 0px 0px 10px 10px;
      line-height: 2;
      .step-label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
      .step-content {
        font-size: 12px;
        color: #898da1;
      }
      ::v-deep .van-step__icon {
        font-size: 18px;
        color: #00ae61 !important;
      }
      ::v-deep .van-step__circle-container {
        top: 27px !important;
      }
      ::v-deep .van-step__line {
        top: 24px !important;
      }
    }
    .van-step:after {
      border: none;
    }
  }
  .detail {
    padding: 15px 15px 0px 15px;
    margin: 15px 15px 0px 15px;
    border-radius: 20px;
    background: white;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
    .detail-title {
      padding-bottom: 15px;
      .van-image {
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
      }
      .detail-title-label {
        color: #1a347b;
        font-size: 14px;
        font-weight: 500;
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .detail-item {
      display: inline-block;
      width: 50%;
      padding-bottom: 15px;
      .van-image {
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 2px;
      }
      .detail-item-label {
        color: #898da1;
        font-size: 12px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
      }
      .detail-item-value {
        color: #000;
        font-size: 12px;
        font-weight: 500;
        font-family: monospace;
        vertical-align: middle;
        display: inline-block;
      }
    }
    .detail-items {
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 15px;
      .detail-items-image {
        width: 100%;
        text-align: center;
        padding-bottom: 15px;
        ::v-deep .van-image__img {
          border-radius: 100px;
        }
      }
    }
  }
}
</style>
